import { Container, Carousel } from "react-bootstrap";
import Alleppey from "../images/home-banner-overlay/Alleppey.jpg";
import jaipur from "../images/home-banner-overlay/jaipur.png";
import sikkim from "../images/home-banner-overlay/sikkim.png";
import "./bannercomponent.css";
import "../stylecomponent.css";
import { useState } from "react";
import {FaLongArrowAltRight} from "react-icons/fa";

function WebBanner() {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };
  return (
    <Container fluid className="p-0 m-0">
      <Carousel
        fade
        controls={false}
        interval={8000}
        activeIndex={index}
        onSelect={handleSelect}
        className="carousel-dark webpongalbanner"
      >
        <Carousel.Item className="CarouselItem banner couselhomebanneren">
          <img
            className="d-block w-100 webbannerholexo"
            src={sikkim}
            alt="Banner2"
          />
          <div className="content">
            <div className="bannertext bannerphnsize">
              <h3 className="banner-heading bannerp-phnsize">
                Unforgettable Holidays
              </h3>
              <h1>
                <b className="acrrossindiafont">Around India</b>
              </h1>
              <p className="bannerp bannerp-phnsize">
                Planned by travel specialists who understand you first.
              </p>
            </div>
          </div>

          <section className="couselhomebannerenbtn">
            <a class="buttonenq top text-white" href="/contact">
            Quick Enquiry <FaLongArrowAltRight/>
            </a>
          </section>
        </Carousel.Item>

        <Carousel.Item className="CarouselItem banner couselhomebanneren">
          <img
            className="d-block w-100 webbannerholexo "
            src={Alleppey}
            alt="Banner1"
          />
          <div className="content border">
            <div className="bannertext bannerphnsize">
              <h3 className="banner-heading bannerp-phnsize">
                Unforgettable Holidays
              </h3>
              <h1>
                <b className="acrrossindiafont">Around India</b>
              </h1>
              <p className="bannerp bannerp-phnsize">
                Planned by travel specialists who understand you first.
              </p>
            </div>
          </div>
          <section className="couselhomebannerenbtn">
            <a class="buttonenq top" href="/contact">
            Quick Enquiry <FaLongArrowAltRight/>
            </a>
          </section>
        </Carousel.Item>
        <Carousel.Item className="CarouselItem banner couselhomebanneren ">
          <img
            className="d-block w-100 webbannerholexo "
            src={jaipur}
            alt="Banner1"
          />
          <div className="content border">
            <div className="bannertext bannerphnsize">
              <h3 className="banner-heading bannerp-phnsize">
                Unforgettable Holidays
              </h3>
              <h1>
                <b className="acrrossindiafont">Around India</b>
              </h1>
              <p className="bannerp bannerp-phnsize">
                Planned by travel specialists who understand you first.
              </p>
            </div>
          </div>
          <section className="couselhomebannerenbtn">
            <a class="buttonenq top" href="/contact">
            Quick Enquiry <FaLongArrowAltRight/>
            </a>
          </section>
        </Carousel.Item>
      </Carousel>

      {/* phn view */}

      <Carousel
        fade
        controls={false}
        interval={8000}
        activeIndex={index}
        onSelect={handleSelect}
        className="carousel-dark pongalbannerphn"
      >
        <Carousel.Item className="CarouselItem banner couselhomebanneren">
          <img
            className="d-block w-100 webbannerholexo"
            src={sikkim}
            alt="Banner2"
          />
          <div className="content">
            <div className="bannertext bannerphnsize">
              <h3 className="banner-heading bannerp-phnsize">
                Unforgettable Holidays
              </h3>
              <h1>
                <b className="acrrossindiafont">Around India</b>
              </h1>
              <p className="bannerp bannerp-phnsize">
                Planned by travel specialists who understand you first.
              </p>
            </div>
          </div>
          <section className="couselhomebannerenbtn">
            <a class="buttonenq top text-white" href="/contact">
            Quick Enquiry <FaLongArrowAltRight/>
            </a>
          </section>
        </Carousel.Item>

        <Carousel.Item className="CarouselItem banner couselhomebanneren">
          <img
            className="d-block w-100 webbannerholexo "
            src={Alleppey}
            alt="Banner1"
          />
          <div className="content border">
            <div className="bannertext bannerphnsize">
              <h3 className="banner-heading bannerp-phnsize">
                Unforgettable Holidays
              </h3>
              <h1>
                <b className="acrrossindiafont">Around India</b>
              </h1>
              <p className="bannerp bannerp-phnsize">
                Planned by travel specialists who understand you first.
              </p>
            </div>
          </div>
          <section className="couselhomebannerenbtn">
            <a class="buttonenq top text-white" href="/contact">
            Quick Enquiry <FaLongArrowAltRight/>
            </a>
          </section>
        </Carousel.Item>
        <Carousel.Item className="CarouselItem banner couselhomebanneren">
          <img
            className="d-block w-100 webbannerholexo "
            src={jaipur}
            alt="Banner1"
          />
          <div className="content border">
            <div className="bannertext bannerphnsize">
              <h3 className="banner-heading bannerp-phnsize">
                Unforgettable Holidays
              </h3>
              <h1>
                <b className="acrrossindiafont">Around India</b>
              </h1>
              <p className="bannerp bannerp-phnsize">
                Planned by travel specialists who understand you first.
              </p>
            </div>
          </div>
          <section className="couselhomebannerenbtn">
            <a class="buttonenq top text-white" href="/contact">
            Quick Enquiry <FaLongArrowAltRight/>
            </a>
          </section>
        </Carousel.Item>
      </Carousel>
    </Container>
  );
}

export default WebBanner;
